import { useDataCache } from '@newageerp/v3.app.data-cache-provider';
import React, { Fragment } from 'react'
import { MP } from '@newageerp/crm-ui'
import SubscriptionsReport1Body from './SubscriptionsReport1Body';

export default function SubscriptionsReport1() {
    const { system: dsSystem } = useDataCache();
    const { settings } = dsSystem.data;

    if (!settings?.realtime?.project) return <Fragment />

    return (
        <MP.GlobalProvider settings={{
            apiKey: settings.mp.apiKey,
            baseUrl: settings.mp.baseUrl,
        }}>
            <SubscriptionsReport1Body />
        </MP.GlobalProvider>
    )
}
